// Reflect selected variant into the URL/price could be added here.
// Kept minimal and dependency-free for maximum compatibility.
document.addEventListener('change', function (e) {
  if (e.target && e.target.matches('#variant-select')) {
    // no-op: native form submit handles the selected variant id
  }
});
